module.exports = __webpack_public_path__ + "static/media/69-sunset.ba0bdb46.JPG";